import React, {useEffect, useState, useRef} from 'react'
import {isEmpty} from 'lodash';
import './_style.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

// Atoms
import HeroContent from "§/src/components/atoms/content/hero-content"

const VideoFull = (props) => {

  // Definisci useRef per vimeoIframe qui
  const vimeoIframe = useRef(null);

  var {
    enableContent,
    video,
    image,
    imageMobile,
    videoMobile,
    videoYt,
    videoVimeo,
    videoVimeoMobile,
    type,
    pausable,
    ...heroContentProps
  } = props.data;
  const videoUrl = video?.publicUrl;

  // Stati per gestire la pausa/play del video Vimeo
  const [isPlaying, setIsPlaying] = useState(true);
  const [vimeoPlayer, setVimeoPlayer] = useState(null);

  // set component class
  const compClassName = '';
  const compClass = props.className !== undefined ? compClassName + ' ' + props.className : compClassName;

  if(type === 'with-controls'){
    useEffect(() => {

      let vimeoPlayer = document.querySelector('#vimeo-video-player');

      function playVid(vid) {
        if (vid.tagName === 'DIV') {
          vid.nextSibling.classList.add('played');
          vimeoPlayer.classList.add('visible');
        } else {
          vid.nextSibling.classList.add('played');
          vid.play();
          vid.setAttribute('controls', 'true');
        }
      }

      function pauseVid(vid) {
        if (vid.tagName === 'DIV') {
          vimeoPlayer.classList.remove('visible');
        } else {
          vid.nextSibling.classList.remove('played');
          vid.pause();
        }
      }

      // EVENT click on play layer button ----------------------
      let playLayer = document.querySelector('.video-play');
      if (playLayer) {
        document.querySelector('.video-play').addEventListener('click', function (event) {
          if (this.classList.contains('played')) {
            pauseVid(this.previousSibling)
          } else {
            playVid(this.previousSibling)
          }
        })
      }

      // EVENTS click on player controls ----------------------
      let controls = document.querySelector('video.controls-video');
      if (controls) {
        document.querySelector('video.controls-video').addEventListener('pause', (event) => {
          pauseVid(event.target)
        })
        document.querySelector('video.controls-video').addEventListener('play', (event) => {
          playVid(event.target)
        })
      }
    }, []) //notice the empty array here - Runs only on the first render
  }

  // Lazy load video iframe
  const [visible, setVisible] = useState(false)
  const videoIframe = useRef(null)
  const [hasScrolled, setHasScrolled] = useState(false)

  // Inizializzazione Vimeo Player API
  useEffect(() => {
    if (visible && (videoVimeo || videoVimeoMobile) && pausable) {
      // Carica l'API Player di Vimeo se non è già caricata
      if (!window.Vimeo && !document.querySelector('script[src*="player.vimeo.com/api/player.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        script.async = true;
        script.onload = initVimeoPlayer;
        document.body.appendChild(script);
      } else if (window.Vimeo) {
        initVimeoPlayer();
      }
    }
  }, [visible, videoVimeo, videoVimeoMobile, pausable]);

  // Inizializza il player Vimeo
  const initVimeoPlayer = () => {
    if (window.Vimeo && videoIframe.current) {
      const player = new window.Vimeo.Player(videoIframe.current);
      setVimeoPlayer(player);
      setIsPlaying(true);
    }
  };

  // Funzione per gestire il pulsante pausa/play
  const togglePlayPause = () => {
    if (vimeoPlayer) {
      if (isPlaying) {
        vimeoPlayer.pause().then(() => {
          setIsPlaying(false);
        }).catch((error) => {
          console.error('Errore durante la pausa del video:', error);
        });
      } else {
        vimeoPlayer.play().then(() => {
          setIsPlaying(true);
        }).catch((error) => {
          console.error('Errore durante la riproduzione del video:', error);
        });
      }
    }
  };

  if(!isEmpty(videoVimeo || videoVimeoMobile)){
    useEffect(() => {
      const handleScroll = () => {
        if (!hasScrolled) {
          setHasScrolled(true);
        }
      };

      window.addEventListener('scroll', handleScroll);

      // All'interno del tuo useEffect per il lazy loading e l'intersezione
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // If the element is visible, change the attribute immediately
            setVisible(true);
          } else if (hasScrolled) {
            // If the user has scrolled but the element is not yet visible, change the attribute when it becomes visible
            setVisible(true);
          }
        });
      }, {
        threshold: 0.05,
      });

      if (videoIframe.current) {
        observer.observe(videoIframe.current);
      }

      window.addEventListener('resize', resizeIframe);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', resizeIframe);
        if (videoIframe.current) {
          observer.disconnect();
        }
      };
    }, [hasScrolled]);
  }

  const containerIframe = useRef(null);

  const resizeIframe = () => {
    const container = containerIframe.current;
    const iframe = videoIframe.current;
    if (!container || !iframe) return;

    const containerRatio = container.offsetWidth / container.offsetHeight;
    const videoRatio = 16 / 9; // Rapporto d'aspetto del video

    let scale = 1;
    if (containerRatio > videoRatio) {
      // Il contenitore è più largo del video, scala in base alla larghezza
      scale = container.offsetWidth / (container.offsetHeight * videoRatio);
      iframe.style.transform = `translate(-50%, -50%) scale(${scale})`;
    } else {
      // Il contenitore è più alto del video, scala in base all'altezza
      scale = container.offsetHeight * videoRatio / container.offsetWidth;
      iframe.style.transform = `translate(-50%, -50%) scale(${scale})`;
    }
  };


  return !isEmpty(videoUrl || videoVimeo || videoVimeoMobile || videoYt || image) ? (

    <div comp="video-full" className={'video-full' + ' ' + type + ' ' + compClass}>

      <div className="video-full-bg">
        {image && (
          <GatsbyImage
            className="sw-image d-none d-sm-block"
            image={getImage(image)}
            objectFit="cover"
            alt={image?.altText || 'video image'}
          />
        )}

        {imageMobile && (
          <GatsbyImage
            className="sw-image d-sm-none"
            image={getImage(imageMobile)}
            objectFit="cover"
            fit="cover"
            alt={imageMobile?.altText || 'video image'}
          />)}
      </div>

      {type === 'with-controls' && (
        videoVimeo || videoVimeoMobile ? (
          <div ref={containerIframe} className="responsive-iframe">
            <iframe
              ref={videoIframe}
              onLoad={resizeIframe}
              id="vimeo-video-player"
              title="cdamedia Vimeo Video"
              src={visible ? "https://player.vimeo.com/video/" + videoVimeo.split('/').pop() : ""}
              className={visible ? 'show' : 'hide'}
              width="640"
              height="360"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen/>
          </div>
        ) : (
          <video
            className="controls-video visibility-hidden"
            src={videoUrl}
            autoPlay={false}
            controls={false}>
          </video>
        )
      )}

      {type === 'bg-loop' && (
        videoVimeo || videoVimeoMobile ? (
          <div ref={containerIframe} className="responsive-iframe">
            <iframe
              ref={videoIframe}
              onLoad={resizeIframe}
              id="vimeo-video-player"
              title="cdamedia Vimeo Video"
              src={visible ? "https://player.vimeo.com/video/" + videoVimeo.split('/').pop() + "?h=2dd8492d0a?muted=1&background=1&autoplay=1&loop=1&byline=0&title=0" : ""}
              className={visible ? 'show' : 'hide'}
              width="640"
              height="360"
              frameBorder="0"
              muted={true}
              controls={false}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen/>
          </div>
        ) : (
          <video
            ref={videoIframe}
            className="bgloop-video visibility-hidden"
            src={videoUrl}
            autoPlay={true}
            muted={true}
            loop={true}
            controls={false}>
          </video>
        )
      )}

      {type === 'with-controls' && (
        videoVimeo && videoVimeoMobile ? (<></>) : (
          <div className="video-play">
            <div className="play"><i></i></div>
          </div>
        )
      )}

      {/* Pulsante pausa/play per video Vimeo */}
      {pausable && (videoVimeo || videoVimeoMobile) && visible && (
        <button
          className={`video-pause-button ${isPlaying ? 'playing' : 'paused'}`}
          onClick={togglePlayPause}
          aria-label={isPlaying ? 'Pausa video' : 'Riproduci video'}
        >
          {isPlaying ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="white" fillOpacity="0.2"/>
              <rect x="8" y="7" width="3" height="10" fill="#fff"/>
              <rect x="13" y="7" width="3" height="10" fill="#fff"/>
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="12" fill="white" fillOpacity="0.2"/>
              <path d="M9 7.5L16 12L9 16.5V7.5Z" fill="#fff"/>
            </svg>
          )}
        </button>
      )}

      {(heroContentProps.pretitle || heroContentProps.title || heroContentProps.subTitle) && enableContent &&
      <HeroContent className="hero-content align-items-start justify-content-end container" data={heroContentProps}/>}

    </div>

  ) : ('');

};

export default VideoFull;
